export default __webpack_public_path__ + "1930b6a726a2a01e53294e570ec317be.png";